import { useContext, useState } from "react";
import HomePage from "../dashboard/HomePage";
import MainBusinessComponent from "../BusinessManagement/MainBusinessComponent";
import ProductPage from "../Product/ProductPage";
import WalletList from "../wallet/WalletList";
import CustomerManagment from "../customer-management/CustomerManagment";
// import ProductPage from "pages/ProductPage";
// import ClubPage from "pages/ClubPage";
import CustomerClub from "../customerClub/CustomerClub";
import FinancialManagement from "../finance/FinancialManagement";
// import WalletList from "pages/WalletList";
import OrdersSuperAdmin from "../Orders/OrdersSuperAdmin";
import AuthenticationContext from "../../../context/Authentication/AuthenticationContext";
import MainList from "../supplier-product/MainList";
import BannerManagement from "../banner-management";
import RequestedProducts from "../../../pages/requested-product/RequestedProducts";
// import CustomerManagment from "pages/CustomerManagment";
// import img from "assets/images/effective-business-team-office-group-work-vector-34356039.jpg";

export default function ManagementContent({ requestId, accessLevel }) {
  const { logout } = useContext(AuthenticationContext);

  const [itemss, setItemss] = useState([]);
  const [updater, setUpdater] = useState(false);

  return (
    <>
      <div class="tab-content container txt-t1-m" id="pills-tabContent">
        <div
          class="tab-pane fade show active container text-center"
          id="pills-welcome"
          role="tabpanel"
          aria-labelledby="pills-welcome-tab"
        >
          <div className="">
            <h5> به مدیریت سبدی خوش آمدید</h5>
          </div>
        </div>

        <div
          class="tab-pane fade "
          id="pills-dashboard"
          role="tabpanel"
          aria-labelledby="pills-dashboard-tab"
        >
          {/* <div>داشبورد</div> */}
          {requestId.includes(1) && (
            <HomePage
              itemss={itemss}
              setItemss={setItemss}
              setUpdater={setUpdater}
              updater={updater}
            />
          )}
        </div>
        <div
          class="tab-pane fade"
          // style={{ height: "90%" }}
          id="pills-business"
          role="tabpanel"
          aria-labelledby="pills-business-tab"
        >
          {requestId.includes(2) && (
            <MainBusinessComponent accessLevel={accessLevel} />
          )}
        </div>
        <div
          // style={{ height: "90%" }}
          class="tab-pane fade"
          id="pills-product"
          role="tabpanel"
          aria-labelledby="pills-product-tab"
        >
          {requestId.includes(3) && <ProductPage accessLevel={accessLevel} />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-customerClub"
          role="tabpanel"
          aria-labelledby="pills-customerClub-tab"
        >
          {requestId.includes(4) && <CustomerClub />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-finance"
          role="tabpanel"
          aria-labelledby="pills-finance-tab"
        >
          {requestId.includes(5) && <FinancialManagement />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-wallet"
          role="tabpanel"
          aria-labelledby="pills-wallet-tab"
        >
          {requestId.includes(6) && <WalletList />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-order"
          role="tabpanel"
          aria-labelledby="pills-order-tab"
        >
          {/* // <div>سفارشات</div> */}
          {requestId.includes(7) && <OrdersSuperAdmin />}
        </div>
        {/* مدیریت کاربران */}
        <div
          class="tab-pane fade "
          id="pills-user"
          role="tabpanel"
          aria-labelledby="pills-user-tab"
        >
          {requestId.includes(8) && <CustomerManagment />}
        </div>

        <div
          class="tab-pane fade "
          id="pills-supplier-product"
          role="tabpanel"
          aria-labelledby="pills-supplier-product-tab"
        >
          {requestId.includes(9) && <MainList />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-banner-management"
          role="tabpanel"
          aria-labelledby="pills-banner-management-tab"
        >
          {requestId.includes(10) && <BannerManagement />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-requested-products"
          role="tabpanel"
          aria-labelledby="pills-requested-products-tab"
        >
          {requestId.includes(11) && <RequestedProducts />}
        </div>
        <div
          class="tab-pane fade "
          id="pills-exit"
          onClick={() => {
            logout();
          }}
        >
          {" "}
          {requestId.includes(8) && <div>خروج</div>}
        </div>
      </div>
    </>
  );
}
